export default __webpack_public_path__ + "static/media/806.9dc1c609.png";